import { normalizeProductOffer } from "../dictionary/offer";

function normalizeDeviceAlias(data) {
  return data?.aliasProducto || null;
}

function normalizeDeviceTechnicalFile(data) {
  return data?.info?.technicalFile || null;
}

function normalizeDeviceCharacteristics(data) {
  return data?.info?.phoneCaracs;
}

function normalizeDeviceTitle(offer) {
  const title = offer?.name;
  if (title) {
    return {
      text: title,
    };
  }

  return null;
}

// abe-cambiar
function normalizeDevicePrice(offer) {
  const price = offer?.pvp_fusion_mv;

  if (price) {
    return {
      price: price,
      currency: "€/mes",
    };
  }

  return null;
}

function normalizeDeviceProductOffering(offer) {
  return offer?.productOffering || null;
}
// abe-cambiar
function normalizeOfferData(data, offerType) {
  let colorList = null;
  let dictionary = null;
  let storageList = null;

  const offers = data?.offers;

  if (offers) {
    for (let [capacity, value] of Object.entries(offers)) {
      if (value && typeof value === "object") {
        if (capacity !== "N/A" && !colorList) {
          colorList = {};
        }

        if (capacity !== "N/A" && !storageList) {
          storageList = [];
        }

        if (capacity !== "N/A") {
          colorList[capacity] = [];
          storageList.push(capacity);
        }

        for (let [color, offerData] of Object.entries(value)) {
          const offerList = offerData[offerType];
          const hasOffers =
            Array.isArray(offerList) && offerData[offerType]?.length >= 1;

          if (colorList && hasOffers) {
            colorList[capacity].push({
              hex: color,
              name: offerData?.colorName,
            });
          }

          if (hasOffers)
            for (let offer of offerList) {
              if (offer?.alias) {
                if (!dictionary) {
                  dictionary = {};
                }

                dictionary[offer?.alias] = {
                  ...normalizeProductOffer(offer),
                  characteristics: normalizeDeviceCharacteristics(data),
                  technicalFile: normalizeDeviceTechnicalFile(data),
                  title: normalizeDeviceTitle(offer),
                  price: normalizeDevicePrice(offer),
                  alias: offer.alias,
                  productOffering: normalizeDeviceProductOffering(offer),
                };
              }
            }
        }

        Object.entries(colorList).forEach(([storage, colors]) => {
          if (colors.length === 0) {
            const index = storageList.indexOf(storage);
            storageList.splice(1, index);
          }
        });
      }
    }
  }

  return { colorList, dictionary, storageList };
}

function main(data, offerType = "r2r") {
  let res = {};

  const { colorList, dictionary, storageList } = normalizeOfferData(
    data,
    offerType
  );

  res.alias = normalizeDeviceAlias(data);
  res.colorList = colorList;
  res.dictionary = dictionary;
  res.storageList = storageList;

  return res;
}

export default main;
